module.exports = __webpack_public_path__ + "static/media/whatsapp.f285204e.svg";